export interface UIState {
  isCreatingNewFolder: boolean;
}

export const uiDefaultState: UIState = {
  isCreatingNewFolder: false,
};

export const setCreateNewFolderMode = (
  isCreatingNewFolder: boolean,
): UIState => ({
  isCreatingNewFolder,
});
